import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function More() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				More
			</Text>
			<Text variant='caption' gutterBottom>
				More
			</Text>
		</Paper>
	)
}
export default More
